import React from 'react';

import { useTranslation } from 'react-i18next';

import './Header.css';

interface HeaderProps {
  toggleNightMode: () => void;
  isNightMode: boolean;
}

const Header: React.FC<HeaderProps> = ({ toggleNightMode, isNightMode }) => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <header className='header'>
      <div className="header-left">
        <span className="header-logo" aria-label="Smarteaming">
          <img src="/logo192.png" alt="Smarteaming" className="header-logo__img" />
        </span>
        <select className="header-select" value={i18n.language} onChange={(e) => handleLanguageChange(e.target.value)} aria-label={t('Language')}>
          <option value="en">{t('English')}</option>
          <option value="fr-FR">{t('Français')}</option>
          <option value="nl">{t('Nederlands')}</option>
        </select>
      </div>
      <div className="header-right" onClick={toggleNightMode}>
        <label htmlFor="theme" className={`theme ${isNightMode ? 'night' : 'day'}`}>
          <span className="theme__toggle-wrap">
            <input id="theme" className="theme__toggle" type="checkbox" role="switch" name="theme" value="dark" checked={isNightMode} readOnly />
            <span className="theme__icon">
              {[...Array(9)].map((_, index) => (
                <span key={index} className="theme__icon-part"></span>
              ))}
            </span>
          </span>
        </label>
      </div>
    </header>
  );
};

export default Header;
